export const FEATURES_LIST = [{
  title: '.NET',
  desc: '基于微软的 .NET 平台，在保持高效开发的同时，对旧的Win32平台提供了完美兼容性',
  img: 'financial-terminal/NET.jpg'
}, {
  title: 'C++',
  desc: '经典的C++语言，依然可以在本客户端内开发组件，延续其稳定的生命力',
  img: 'financial-terminal/C++.jpg'
}, {
  title: 'python',
  desc: '业界最流行的Python语言，我们提供接口给用户，使其能够定制自己的功能与逻辑',
  img: 'financial-terminal/python.jpg'
}, {
  title: '高效性能',
  desc: '多线程模块化运行系统服务，新能显著提升；双链接方式，新增交易全面支持非交易业务；登陆启动、断线重连、页面缓存、DPI适配、资金刷新',
  img: 'financial-terminal/HighPerformance.jpg'
}];
export const SKILL_LIST = [{
  img: 'EnrichMarket.png',
  title: '丰富行情',
  desc: '提供A股、B股、港股、美股、债券、CDR、沪伦通、股指期货、外汇、股票期权、现货、基金等行情展示'
}, {
  img: 'Fulltransaction.png',
  title: '全量交易',
  desc: '支持条件单、python指标等策略交易；支持组合交易及算法交易功能，满足多样化的交易需求'
}, {
  img: 'marketLinkage.png',
  title: '交易+行情联动',
  desc: '下单界面作为多窗口显示，行情、交易界面互不影响，买卖操作极为便捷'
}, {
  img: 'FeaturedTools.png',
  title: '特色工具',
  desc: '拥有问财融合、键盘精灵、AI相似个股、特色指标、高速行情L2等特色功能'
}, {
  img: 'VisualizeData.png',
  title: '可视化数据资讯',
  desc: '支持热点盯盘、事件驱动、涨跌停分析、市场资金、宏观数据、 ifind F9接入等功能'
}, {
  img: 'OperationHomepage.png',
  title: '运营首页',
  desc: '支持券商官网、官微、手机app导流及banner轮播图、消息公告等中台运营'
}, {
  img: 'PanoramicKanban.png',
  title: '全景看盘',
  desc: '采用九宫格的方式，全景展示市场行情、热点及资金流向信息'
}, {
  img: 'synchronization.png',
  title: '自选股同步',
  desc: '通过绑定自选股关联的手机号，实现PC自选股与手机自选股同步'
}, {
  img: 'Level2高速行情.png',
  title: 'Level2高速行情',
  desc: '千档盘口深度，毫秒级刷新速度，便于观察远距离大挂单和垫单的情况'
}];